import { ListItemLayout, ListItemSegment } from 'layouts/lists'
import { ListItemTitle } from 'components/lists/common'
import { TitleWrapper } from './ListItemsGroupName.styled'

export type ListItemsGroupNameProps = {
  groupName?: string
}

const ListItemsGroupName: React.FC<ListItemsGroupNameProps> = ({ groupName }) => {
  if (!groupName) return null
  return (
    <ListItemLayout data-test='ListItemsGroupName'>
      <ListItemSegment segmentId='content'>
        <TitleWrapper>
          <ListItemTitle title={groupName} data-test='ListItemsGroupNameTitle' />
        </TitleWrapper>
      </ListItemSegment>
    </ListItemLayout>
  )
}

export default ListItemsGroupName
